import NoteIcon from "@mui/icons-material/Note";
import EventAvailableIcon from "@mui/icons-material/EventAvailable";
import PeopleIcon from "@mui/icons-material/People";
import FileCopyIcon from "@mui/icons-material/FileCopy";
import TextSnippetIcon from "@mui/icons-material/TextSnippet";
import MenuSharpIcon from "@mui/icons-material/MenuSharp";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExploreIcon from "@mui/icons-material/Explore";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import PaymentIcon from "@mui/icons-material/Payment";
import ChatIcon from "@mui/icons-material/Chat";
import PersonIcon from "@mui/icons-material/Person";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import FolderOpenIcon from "@mui/icons-material/FolderOpen";
import DescriptionIcon from "@mui/icons-material/Description";
import AssignmentIcon from "@mui/icons-material/Assignment";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import TrackChangesIcon from "@mui/icons-material/TrackChanges";
import ScheduleIcon from "@mui/icons-material/Schedule";
import ShareIcon from "@mui/icons-material/Share";
import {
  Dashboard as DashboardIcon,
  Assignment as RequirementIcon,
  Shop,
  Settings,
} from "@mui/icons-material";
import BarChartIcon from "@mui/icons-material/BarChart";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import EventRepeatIcon from "@mui/icons-material/EventRepeat";
import AssessmentIcon from "@mui/icons-material/Assessment";
import HistoryIcon from "@mui/icons-material/History";
import GetAppIcon from "@mui/icons-material/GetApp";
import RequestQuoteIcon from "@mui/icons-material/RequestQuote";
import ShowChartIcon from "@mui/icons-material/ShowChart";
import LightbulbIcon from "@mui/icons-material/Lightbulb";
import ForumIcon from "@mui/icons-material/Forum";
import RecordVoiceOverIcon from "@mui/icons-material/RecordVoiceOver";
import NotificationsIcon from "@mui/icons-material/Notifications";

export const sidebar = {
  gp: [
    {
      name: "Dashboard",
      icon: <DashboardIcon />,
      link: "/global-partner/dashboard",
    },
    {
      name: "Trade Marketplace",
      icon: <FileCopyIcon />,
      submenu: [
        {
          name: "My Trade Dashboard",
          path: "/global-partner/trade/dashboard",
          icon: <DashboardIcon />,
        },
        {
          name: "Discover & Evaluate",
          label: "Discover & Evaluate",
          path: "/global-partner/discoverevaluate",
          icon: <ExploreIcon />,
        },
        {
          name: "Requirements",
          label: "Requirement",
          path: "/global-partner/requirement",
          icon: <RequirementIcon />,
        },
        {
          name: "RFQs & Offers",
          label: "RFQs & Offers",
          path: "/global-partner/rfqoffers",
          icon: <RequestQuoteIcon />,
        },
        {
          name: "Orders",
          label: "Orders",
          path: "/global-partner/orders",
          icon: <LocalShippingIcon />,
        },
      ],
    },

    // {
    //   name: "All Offers",
    //   icon: <RequirementIcon />,
    //   link: "/global-partner/offers",
    // },
    {
      name: "Finance Marketplace",
      icon: <EventAvailableIcon />,
      submenu: [
        {
          name: "My Finance Dashboard",
          label: "My Finance Dashboard",
          path: "/global-partner/finance/h",
          icon: <RequirementIcon />,
        },
        {
          name: "Discover & Evaluate",
          label: "Discover & Evaluate",
          path: "/global",
          icon: <ExploreIcon />,
        },
        {
          name: "RFQs & Offers",
          label: "RFQs & Offers",
          path: "/global-partner/finance/rfqoffers",
          icon: <RequestQuoteIcon />,
          submenu: [
            {
              name: "Payment & Financing Instruments",
              path: "/global-partner/finance/rfqoffers",
              icon: <ExploreIcon />,
            },
            {
              name: "Working Capital & Liquidity",
              path: "/global-partner/offers/working-capital",
              icon: <ExploreIcon />,
            },
            {
              name: "Risk Mitigation Tools",
              path: "/global-partner/offers/risk-mitigation",
              icon: <ExploreIcon />,
            },
            {
              name: "FX & Hedging Solutions",
              path: "/global-partner/offers/fx-hedging",
              icon: <ExploreIcon />,
            },
          ],
        },
        {
          name: "Apply for Finance",
          label: "My Offers",
          path: "/global-partner/ordersn",
          icon: <LocalShippingIcon />,
        },
        {
          name: "Application Tracker",
          label: "My Offers",
          path: "/global-partner/ordersns",
          icon: <LocalShippingIcon />,
        },
      ],
    },
    // {
    //   name: "Payment",
    //   icon: <PaymentIcon />,
    //   link: "/global-partner/payment",
    // },
    {
      name: "Documents Vault",
      icon: <FolderOpenIcon />,
      submenu: [
        {
          name: "All Documents",
          path: "/global-partner/documentvault",
          icon: <DescriptionIcon />,
        },
        // {
        //   name: "KYC Documents",
        //   path: "/global-partner/d",
        //   icon: <DescriptionIcon />,
        // },
        // {
        //   name: "Trade Contracts / POs",
        //   path: "/global-partner/documents/trade-contracts",
        //   icon: <AssignmentIcon />,
        // },
        // {
        //   name: "LC / SBLC Documents",
        //   path: "/global-partner/documents/lc-sblc",
        //   icon: <AssignmentIcon />,
        // },
        // {
        //   name: "Invoices",
        //   path: "/global-partner/documents/invoices",
        //   icon: <ReceiptLongIcon />,
        // },
        // {
        //   name: "Shipping / Customs Docs",
        //   path: "/global-partner/documents/shipping-customs",
        //   icon: <LocalShippingIcon />,
        // },
        // {
        //   name: "Upload / Share with Finance Partner",
        //   path: "/global-partner/documents/upload-share",
        //   icon: <ShareIcon />,
        // },
      ],
    },
    {
      name: "Shipments & Logistics",
      icon: <LocalShippingIcon />,
      submenu: [
        {
          name: "Logistics",
          path: "/global-partner/shipments/page",
          icon: <LocalShippingIcon />,
        },
        {
          name: "Track Shipments",
          path: "/global-partner/shipments/track",
          icon: <TrackChangesIcon />,
        },
        {
          name: "Partner Logistics Providers",
          path: "/global-partner/shipments/partners",
          icon: <PeopleIcon />,
        },
        {
          name: "Documents for Customs / Insurance",
          path: "/global-partner/shipments/documents",
          icon: <DescriptionIcon />,
        },
        {
          name: "Delivery Timelines",
          path: "/global-partner/shipments/timelines",
          icon: <ScheduleIcon />,
        },
      ],
    },
    {
      name: "Analytics & Finance",
      icon: <BarChartIcon />,
      submenu: [
        {
          name: "Trade Value",
          path: "/global-partner/analytics/trade-value",
          icon: <AttachMoneyIcon />,
        },
        {
          name: "Finance Usage",
          path: "/global-partner/analytics/finance-usage",
          icon: <AccountBalanceIcon />,
        },
        {
          name: "Repayment Schedule",
          path: "/global-partner/analytics/repayment",
          icon: <EventRepeatIcon />,
        },
        {
          name: "Credit Score Insights",
          path: "/global-partner/analytics/credit-score",
          icon: <AssessmentIcon />,
        },
        {
          name: "Shipment History",
          path: "/global-partner/analytics/shipment-history",
          icon: <HistoryIcon />,
        },
        {
          name: "Export/Download Data",
          path: "/global-partner/analytics/export",
          icon: <GetAppIcon />,
        },
      ],
    },
    // {
    //   name: "Seller Bank Communications",
    //   icon: <ChatIcon />,
    //   submenu: [
    //     {
    //       name: "Chat Message Center",
    //       path: "/global-partner/communications/chat",
    //       icon: <ForumIcon />,
    //     },
    //     {
    //       name: "Negotiation Logs",
    //       path: "/global-partner/communications/negotiation",
    //       icon: <RecordVoiceOverIcon />,
    //     },
    //     {
    //       name: "Alerts & Notifications",
    //       path: "/global-partner/communications/alerts",
    //       icon: <NotificationsIcon />,
    //     },
    //   ],
    // },
    {
      name: "Profile",
      icon: <PeopleIcon />,
      link: "/global-partner/profile",
    },
    {
      name: "Settings",
      icon: <Settings />,
      link: "/global-partner/setting",
    },
    {
      name: "Support",
      icon: <SupportAgentIcon />,
      link: "/global-partner/support",
    },
    {
      name: "Messaging",
      icon: <ChatIcon />,
      link: "/global-partner/messaging",
    },
    {
      name: "User & Roles",
      icon: <PeopleIcon />,
      link: "/global-partner/user-role",
    },
  ],
};

export const sidebarGpBuyer = {
  gpbuyer: [
    {
      name: "Dashboard",
      icon: <DashboardIcon />,
      link: "/global-partner-buyer/dashboard",
    },
    {
      name: "My Buyers",
      icon: <PersonIcon />,
      link: "/global-partner-buyer/my-buyers", // Updated to a unique path
    },
    {
      name: "Requirements",
      icon: <RequestQuoteIcon />,
      link: "/global-partner-buyer/requirement", // Updated to a unique path
    },
    {
      name: "RFQs",
      icon: <RequestQuoteIcon />,
      link: "/global-partner-buyer/rfqoffers", // Updated to a unique path
    },
    // {
    //   name: "Orders",
    //   icon: <LocalShippingIcon />, // Changed icon to be more relevant
    //   link: "/global-partner-buyer/orders", // Updated to a unique path
    // },
    {
      name: "Offers",
      icon: <RequirementIcon />, // Changed icon to be more relevant
      link: "/global-partner-buyer/offers", // Updated to a unique path
    },
    {
      name: "Trade",
      icon: <Shop />,
      link: "/global-partner-buyer/trade",
    },
  ],
};
